import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  return <section className="bg-dark py-20 px-4 border-t border-gray-800" data-id="element-10">
      <div className="max-w-[900px] mx-auto flex flex-col items-center" data-id="element-11">
        <h2 className="md:text-4xl font-bold text-white mb-4 text-center text-[28px]" data-id="element-12">
          LO QUE TE LLEVAS
        </h2>
        <p className="text-xl text-white mb-12 text-center" data-id="element-13">
          Para que esto no se vuelva a desordenar
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full" data-id="element-14">
          <div className="bg-[#111111] border border-gray-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-15">
            <Check className="text-accent mb-4" size={40} data-id="element-16" />
            <p className="text-lg text-white font-medium" data-id="element-17">
              Delegación inteligente, para dejar de ser el cuello de botella.
            </p>
          </div>

          <div className="bg-[#111111] border border-gray-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-18">
            <Check className="text-accent mb-4" size={40} data-id="element-19" />
            <p className="text-lg text-white font-medium" data-id="element-20">
              Mapa 80/20 real, para sostener lo que sí funciona.
            </p>
          </div>

          <div className="bg-[#111111] border border-gray-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-21">
            <Check className="text-accent mb-4" size={40} data-id="element-22" />
            <p className="text-lg text-white font-medium" data-id="element-23">
              Criterio para eliminar lo que solo te mantiene ocupada.
            </p>
          </div>

          <div className="bg-[#111111] border border-gray-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-24">
            <Check className="text-accent mb-4" size={40} data-id="element-25" />
            <p className="text-lg text-white font-medium" data-id="element-26">
              Enfoque sobre lo que sí impacta crecimiento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}